import { useContext, useState } from 'react';
import { AuthContext } from '../services/authContext';
import { Navigate } from 'react-router-dom';
import { Row, Col, Button } from 'react-bootstrap';
import '../scss/components/dashboard.scss';
import UserInfo from '../components/modules/dashboard/UserInfo';
import UserDashTiles from '../components/modules/dashboard/UserDashTiles';

const Dashboard = () => {
    const { isLoggedIn, userProfile } = useContext(AuthContext);
    if (!isLoggedIn || !userProfile) {
        return <Navigate to="/" />;
    }

    return (
        <div id="Dashboard" className="screen">
            <Row>
                <Col xs={12} className="p-0">
                    <Row>
                        <Col xs={12}>
                            <UserInfo />
                        </Col>
                    </Row>
                </Col>
            </Row>
            <UserDashTiles />
        </div>
    );
};

export default Dashboard;
